import IconCaret from '../../../icons/IconCaret';

const ArrowIcon = () => {
	return (
		<IconCaret
			orientation={'up'}
			handle={`vtex-search-result-3-x-filterIcon filterIcon flex items-center ph5 c-muted-3`}
			size={16}
		/>
	);
};

export default ArrowIcon;
